<div class="2xl:py-8 lg:py-4 py-2 2xl:px-96 xl:px-72 lg:px-48 md:px-24 sm:px-12 px-6 h-screen">
  <div class="xl:hidden">
    <div class="mb-5 p-4 bg-white rounded-md">
      <div class="flex flex-grow">
        <img
          [src]="'logo_large' | providerImage"
          [alt]="'logo_large' | providerImage: 'altText'"
          class="my-4 px-4 object-contain max-h-40 w-full"
        />
      </div>
    </div>

    <div class="flex items-center justify-between gap-4 mb-4">
      <div class="flex items-center gap-2 lg:hidden">
        <button class="button-circle" (click)="changeDisplay('map')" [class.selected]="display === 'map'">
          <i class="fa-light fa-location-dot"></i>
        </button>
        <button class="button-circle" (click)="changeDisplay('list')" [class.selected]="display === 'list'">
          <i class="fa-kit fa-list"></i>
        </button>
      </div>
      <div class="lg:ml-auto flex items-end">
        <button class="button-primary rounded-md w-full mr-1" [routerLink]="'/login'">
          <i class="fa fa-user"></i>
          <div [innerText]="'Common.LogIn' | translate"></div>
        </button>
        @if(signUpEnabled) {
          <button class="button-primary-outlined rounded-md w-full" [routerLink]="'/onboarding'">
            <div [innerText]="'Common.Register' | translate"></div>
            <i class="fa fa-arrow-right-to-bracket"></i>
          </button>
        }
      </div>
    </div>
  </div>

  <div class="max-xl:hidden flex">
    <div class="w-full">
      <div class="p-4 rounded-t-md bg-white">
        <div class="flex flex-grow">
          <img
            [src]="'logo_large' | providerImage"
            [alt]="'logo_large' | providerImage: 'altText'"
            class="my-4 px-4 object-contain max-h-40 w-full"
          />
        </div>
      </div>
    </div>

    <div class="w-[320px] bg-white">
      <div class="flex h-full px-3">
        <div class="flex items-end mb-4 w-full">
          <button class="button-primary rounded-md mr-1 ml-auto w-40" [routerLink]="'/login'">
            <i class="fa fa-user"></i>
            <div [innerText]="'Common.LogIn' | translate"></div>
          </button>
          @if(signUpEnabled) {
            <button class="button-primary-outlined rounded-md w-40" [routerLink]="'/onboarding'">
              <div [innerText]="'Common.Register' | translate"></div>
              <i class="fa fa-arrow-right-to-bracket"></i>
            </button>
          } 
        </div>
     </div>
    </div>
  </div>

  <div class="map-wrapper h-1/2">
    <div class="map flex-grow lg:block" [ngClass]="display === 'map' ? 'block' : 'hidden'">
      <div id="map" class="map"></div>
    </div>
    <div class="map-panel lg:block overflow-auto" [ngClass]="display === 'list' ? 'block' : 'hidden'">
      <div class="flex flex-col">
        <div class="input-primary-container sticky top-0 bg-white z-10">
          <input
            id="garageFilter"
            class="input-primary pr-10"
            type="text"
            [(ngModel)]="markerFilter"
            (input)="filterMarkers()"
            addEmptyPlaceholder
          />
          <label for="garageFilter" [innerText]="'Products.Search' | translate"></label>
          <button *ngIf="markerFilter" class="absolute right-2 top-1/2 transform -translate-y-1/2" (click)="clearMarkerFilter()">
            <i class="text-neutral-70 fa fa-times"></i>
          </button>
        </div>
        @for (marker of filteredMapMarkers; track $index) {
          <div
            class="garage-list-item"
            #markerElement
            [attr.data-id]="marker.id"
            [class.bg-decoration-transparent-8]="marker === selectedMapMarker"
            (click)="updateSelectedMarker(marker, true)"
          >
            <div class="garage-list-item-content">
              <div class="text-2xl text-decoration">
                <i class="fa-kit fa-parking"></i>
              </div>
              <div>
                <div class="body-large mb-0.5" [innerText]="marker.name"></div>
                <div class="body-medium">
                  <span class="text-neutral-50" [innerText]="formatAddress(marker)"></span>
                </div>
                @if (userLocation) {
                  <div class="body-medium mt-2">
                    <span class="text-neutral-50" [innerText]="formatDistance(distanceToUser(marker))"></span>
                  </div>
                }
              </div>
            </div>
          </div>
        } @empty {
          <div class="text-center p-6">
            <div class="text-neutral-50 text-2xl">
              <i class="fa-kit fa-map"></i>
            </div>
            <div class="body-medium mt-2">
              <span class="text-neutral-50" [innerText]="'Locations.NoLocationsFound' | translate"></span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Mobile -->
  <div class="garage-details-dialog">
    <arivo-bottom-sheet-dialog
      #garageDetailsDialog
      [open]="selectedMapMarker !== undefined"
      (onClose)="updateSelectedMarker(undefined)"
      [dynamicWidth]="true"
    >
      <app-garage-details [garage]="selectedMapMarker" [allowContractCreation]="false" />
    </arivo-bottom-sheet-dialog>
  </div>

  <!-- Desktop -->
  <div class="garage-details mt-4">
    <app-garage-details [garage]="selectedMapMarker" [allowContractCreation]="false" />
  </div>

  <div class="my-4">
    <div class="footer-languages flex flex-row items-center justify-center bottom-0">
      <a (click)="changeLanguage('de')" [class.active]="getCurrentLanguage() === 'de'">Deutsch</a>
      <div class="mx-1">|</div>
      <a (click)="changeLanguage('en')" [class.active]="getCurrentLanguage() === 'en'">English</a>
    </div>
    <arivo-legal-links></arivo-legal-links>
  </div>
</div>
